import { createAction } from '@reduxjs/toolkit';
import { shopSlice } from './reducer';

export const { receiveTags, resetTags, setTags } = shopSlice.actions;

export const fetchTagsData = createAction('shop/fetchTags');
